// extracted by mini-css-extract-plugin
export default {"react-select__control":"Selector_react-select__control__deFiY","selector":"Selector_selector__eKTmu"};